import { render, staticRenderFns } from "./ViewMessages.vue?vue&type=template&id=69f8f4ec&scoped=true"
import script from "./ViewMessages.vue?vue&type=script&lang=js"
export * from "./ViewMessages.vue?vue&type=script&lang=js"
import style0 from "./ViewMessages.vue?vue&type=style&index=0&id=69f8f4ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69f8f4ec",
  null
  
)

export default component.exports